import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from '../../../stores/store';
import { ConsumerType } from '../../../model/energy-profile';
import { SubMenuItem } from './CustomerMenu.types';

export const useSubMenuVisibility = () => {
  const energyProfile = useSelector((state: RootState) => state.customerEnergyProfile);
  
  const visibility: Record<string, boolean> = {
    'energy-management': energyProfile.consumerType === ConsumerType.Postpaid,
  };

  const filterVisibleItems = useCallback((subMenuItems?: SubMenuItem[]) => {
    return subMenuItems?.filter((subItem) => visibility[subItem.id] ?? subItem.isShow ?? true);
  }, [visibility]);

  return { filterVisibleItems };
};